"use client";

import CustomIcon from "@/components/ui/custom-icon";
import FormField from "@/components/ui/form-field";
import S from "./index.module.scss";
import { REQUEST_FORM_FIELDS } from "./constants";
import { useConfiguratorData } from "@/views/configurator/hooks/useConfiguratorData";
import { Controller, FormProvider } from "react-hook-form";
import Link from "next/link";

const RequestForm = () => {
  const { methods, isPending, onSubmit, isSuccess } = useConfiguratorData();

  return (
    <FormProvider {...methods}>
      <form className={S.form} noValidate onSubmit={onSubmit}>
        <h2 className={S.title}>Оставить заявку</h2>

        <div className={S.fields}>
          {REQUEST_FORM_FIELDS.map(field => (
            <FormField key={field.id} field={field} />
          ))}
        </div>

        <Controller
          control={methods.control}
          name="files"
          render={({ field, fieldState }) => {
            const selectedFiles =
              Array.isArray(field.value) && field.value.length ? field.value.map(file => file.name).join(", ") : "";

            return (
              <>
                <div className={S.uploadField}>
                  <label className={S.uploadLabel} htmlFor="files">
                    Прикрепить файл
                  </label>
                  <div className={S.uploadControl}>
                    <CustomIcon fileName="icon-upload" className={S.uploadIcon} />
                    <span>{selectedFiles || "Загрузите референсы или эскизы"}</span>
                    <input
                      id="files"
                      type="file"
                      multiple
                      className={S.fileInput}
                      onBlur={field.onBlur}
                      ref={field.ref}
                      onChange={event => {
                        field.onChange(Array.from(event.target.files || []));
                      }}
                    />
                  </div>
                  <p className={S.uploadHint}>Допустимые форматы: JPG, PNG, PDF (максимум 10MB)</p>{" "}
                  {fieldState.error?.message ? <p className={S.error}>{fieldState.error?.message}</p> : null}
                </div>
              </>
            );
          }}
        />

        {methods.formState.errors.root?.serverError?.message && (
          <p className={S.error}>{methods.formState.errors.root.serverError.message}</p>
        )}

        {isSuccess && <p className={S.success}>Заявка успешно отправлена</p>}

        <button onClick={onSubmit} className={S.submitButton}>
          {isPending ? "Отправляем..." : "Отправить заявку"}
        </button>

        <p className={S.policy}>
          Нажимая кнопку «Отправить заявку», вы соглашаетесь с условиями{" "}
          <Link href="/policy">Политики конфиденциальности</Link>
        </p>
      </form>
    </FormProvider>
  );
};

export default RequestForm;
